import { useMutation } from "@tanstack/react-query";
import {
  recordImageViewApiPublicImagesImageIdViewPost,
  recordAlbumViewApiPublicAlbumsAlbumIdViewPost,
} from "../api/generated";

/**
 * Hook to record an image view.
 */
export function useRecordImageView() {
  return useMutation({
    mutationFn: async (imageId: string) => {
      const response = await recordImageViewApiPublicImagesImageIdViewPost({
        path: { image_id: imageId },
      });

      if (response.error) {
        throw new Error("Failed to record image view");
      }

      return response.data;
    },
    // Don't retry on failure - views are not critical
    retry: false,
  });
}

/**
 * Hook to record an album/gallery view.
 */
export function useRecordAlbumView() {
  return useMutation({
    mutationFn: async (albumId: string) => {
      const response = await recordAlbumViewApiPublicAlbumsAlbumIdViewPost({
        path: { album_id: albumId },
      });

      if (response.error) {
        throw new Error("Failed to record album view");
      }

      return response.data;
    },
    // Don't retry on failure - views are not critical
    retry: false,
  });
}
